import {ViewMode} from '../../core-utilities/enums/ViewMode';
import PropTypes from 'prop-types';

export const FORM_MODE = {
  /* Requesting form to edit */
  LOADING: 'loading',
  /* Requesting to save changes */
  SAVING: 'saving',
  /* Successfully loaded latest model (also, successfully saved changes and now displaying latest model) */
  SUCCESS: 'success',
  /* Validation error(s) with model. Unable to save. */
  EVALID: 'invalid',
  /* Misc error. */
  EOTHER: 'error',
  /* Unable to load or save due to failure to connect to server. */
  ENONET: 'no_network',
};

export const isFormMode = PropTypes.oneOf(Object.values(FORM_MODE));

FORM_MODE.toViewMode = mode => {
  switch (mode) {
    case FORM_MODE.LOADING:
      return ViewMode.LOADING;

    case FORM_MODE.SAVING:
    case FORM_MODE.SUCCESS:
    case FORM_MODE.EVALID:
      return ViewMode.SUCCESS;

    case FORM_MODE.EOTHER:
      return ViewMode.EOTHER;

    case FORM_MODE.ENONET:
      return ViewMode.ENONET;

  }
};



// WEBPACK FOOTER //
// ./src/js/forms/enums/FormMode.js